import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
/* eslint-disable import/named */
import { MultiValue } from 'react-select';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import MultiSelectSortable, {
  ReactSelectOption,
} from '../Selects/SortableSelect';
import { Selector, Option } from '../Selects/Selector';

export interface PricingGroupMultiSelectorProps {
  readOnly?: boolean;
  selectedPricingGroup?: ReactSelectOption[];
  onChangeMulti?: (options: MultiValue<ReactSelectOption>) => void;
  multi?: boolean;
  value?: string;
  onChange?: (option: Option) => void;
}

export default (props: PricingGroupMultiSelectorProps) => {
  const spd = useSpdCore();
  const [pricingGroup, setPricingGroup] = useState<ReactSelectOption[]>([]);
  const [ready, setReady] = useState(false);
  const [displayName, setDisplayName] = useState<string>();

  useEffect(() => {
    let mounted = true;
    spd.pricingGroups
      .getAll()
      .then(t => {
        if (mounted) {
          const result = t
            .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
            .map(
              a =>
                ({
                  value: a.id,
                  label: a.name,
                }) as ReactSelectOption,
            );
          setPricingGroup(result);
          setReady(true);
        }
      })
      .catch(error =>
        console.log(`Wystąpił problem z pobraniem grup cenowych. ${error}`),
      );

    return () => {
      mounted = false;
    };
  }, [spd.pricingGroups]);

  useEffect(() => {
    let mounted = true;
    if (!props.multi) {
      if (props.value) {
        spd.pricingGroups
          .get(props.value)
          .then(pricGr => {
            if (mounted) {
              setDisplayName(pricGr.name || '');
            }
          })
          .catch(error =>
            console.log(`Wystąpił problem z pobraniem grup cenowych. ${error}`),
          );
      } else {
        setDisplayName('');
      }
    }
    return () => {
      mounted = false;
    };
  }, [props.multi, props.value, spd.pricingGroups]);

  const provider = async (text: string) => {
    const values = pricingGroup.filter(v => {
      const name = v.label || '';
      return name.toLocaleLowerCase().includes(text.toLocaleLowerCase());
    });

    return values.map(v => {
      return {
        label: v.label || '',
        value: v.value,
      };
    });
  };

  return ready ? (
    props.multi ? (
      <MultiSelectSortable
        options={pricingGroup}
        defaultValue={props.selectedPricingGroup || []}
        onChange={options =>
          props.onChangeMulti && props.onChangeMulti(options)
        }
      />
    ) : (
      <Selector
        uniqueKey={
          'pricinigGroup-' + JSON.stringify(pricingGroup) + displayName
        }
        readOnly={props.readOnly}
        creatable={false}
        placeholder={'Wskaż...'}
        provider={provider}
        value={displayName}
        onChange={props.onChange}
        clearable={true}
      />
    )
  ) : (
    <Skeleton />
  );
};
